import React, { Component, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action, AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState, ModalCustom, ExcelImporter } from '../.././Componet';
import { useParams, useNavigate } from "react-router-dom";
import { Route,Link } from "react-router-dom";
import { Modal } from 'bootstrap';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'
import { data, param } from 'jquery';

function SetUsers(props) {

    const [pageState, setState] = useState({ records: [], isLoaded: false });

    const load = () => {
        let h = new Helper();
        h.Ajax('UserManger', 'GetAll', {}, (data) => {
            setState({ records: data, isLoaded:true });

        });

    };
    const submit = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        h.Ajax('UserManger', 'SetUsers' , { users:window.users }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    };

    if (pageState.isLoaded == false) {
        load();
        return <LoadingBar />;
    }
    return <FromSubmit submitBev={submit} >
        <ProTable datasourcename="users" Records={pageState.records}>
            <Column metaForDisplay={DataClass.UserInServiceSetthing.UserId} />
            <Column metaForDisplay={DataClass.UserInServiceSetthing.UserName} />
            <Column metaForInput={DataClass.UserInServiceSetthing.UserServiceType} />
            <Column columnName="isFixer" caption="آیا فیبربان است" type={ColumnType.InputCheck}  />
        </ProTable>

    </FromSubmit>

}
class UsageStuffMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("UsageStuff", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.UsageStuffs);
        h.Ajax('UsageStuff', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='UsageStuffs' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.UsageStuff.Id} />
                    <Column metaForInput={DataClass.UsageStuff.Name} />
                    <Column metaForInput={DataClass.UsageStuff.StuffType} />
                    <Column metaForInput={DataClass.UsageStuff.TypeState} />
                    <Column metaForInput={DataClass.UsageStuff.Description} />
        

                </ProTable>

            </FromSubmit>

        }

    }


}


export class DelevryUsageMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('DelevryUsage', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('DelevryUsage', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='DelevryUsage' /> <ProTable Records={this.state.Records} datasourcename='DelevryUsages'>
                    <Column metaForDisplay={DataClass.DelevryUsage.id} />
                    <Column metaForDisplay={DataClass.DelevryUsage.UserId} />
                    <Column columnName="userName" type={ColumnType.DisplayValue} caption="کاربر"   />

                    <Column metaForDisplay={DataClass.DelevryUsage.MoveTime} />
                    <Column metaForDisplay={DataClass.DelevryUsage.MoveType} />
                    <Column metaForDisplay={DataClass.DelevryUsage.Descr} />
                    <Column metaForDisplay={DataClass.DelevryUsage.ItemDescr} />
                    <Action caption="ویرایش" type="Link" pageName="/DelevryUsage/Edit" columnName="id" />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}
function NewMission(props) {
    let id = -1;
    let params = useParams();
     
    if (params.id !== undefined) {
        id = params.id;
    }
    const submit = () => {
        let h = new Helper();
     
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        h.Ajax('Mission', 'Create', { model: h.GetPostData(),id:id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                if (id != -1) {

                    h.GoBack();
                }
                else {
                    $('#txtMobile').val('');
                    $('#txtFullName').val('');
                    $('#txtAddress').val('');
                    $('#txtDescr').val('');
                    $('#txtDescrForInstaller').val('');

                    $('#txtDescrForFijaner').val('');
                   
                   
                }
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    };
    
    const load = () => {
        let h = new Helper();


        h.Ajax('Mission', 'Get', { id: id, type: 1 }, function (data) {

            h.SetDataBack(data.model);

           
            
        });

    };
    if (id != -1) {
        load();
    }
    else {
        let h = new Helper();
        h.Ajax('FTTHRequest', 'LoadData', { id: -1 }, function (data) {
            
            $('#txtUnitPrice').val(data.unitPrice);
        });
    }

    return <FromSubmit submitBev={submit}>
        <InputBox meta={DataClass.ServiceMission.FullName} size='33%'  />
        <InputBox meta={DataClass.ServiceMission.Mobile} size='33%' />
        <InputBox meta={DataClass.ServiceMission.ProitityType} size='33%' />
        
        <InputBox meta={DataClass.ServiceMission.FiojanerUserId} size='33%' />
        <InputBox meta={DataClass.ServiceMission.InstallerUserId} size='33%' />
        {id == -1 &&

            <InputBox meta={DataClass.NewMissionDto.UnitPrice} size='33%' />
        }

        <InputBox meta={DataClass.ServiceMission.Address} />
       

        <InputBox meta={DataClass.ServiceMission.Descr} />

        <InputBox meta={DataClass.ServiceMission.DescrForInstaller} size='100%' />
        <InputBox meta={DataClass.ServiceMission.DescrForFijaner} size='100%' />


    </FromSubmit>
}

function CanDoIt(props) {
    let id = -1;
    let params = useParams();
    const [pageState, setState] = useState({ usages: window.usage });
    if (params.id !== undefined) {
        id = params.id;
    }
    const submit = () => {
        let h = new Helper();

        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        h.Ajax('Mission', 'ICantDoit', { model: h.GetPostData(), id: id, usages: window.usage }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                if (id != -1) {

                    h.GoBack();
                }
                else {
                    $('#txtMobile').val('');
                    $('#txtFullName').val('');
                    $('#txtAddress').val('');
                    $('#txtDescr').val('');
                    $('#txtDescrForInstaller').val('');

                    $('#txtDescrForFijaner').val('');
                }
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    };

     


    return <FromSubmit submitBev={submit}>
         <InputBox meta={DataClass.ServiceMission.InstallerUserId} size='50%' />
 

        <InputBox meta={DataClass.ServiceMission.Descr} />
        <ProTable datasourcename="usage" Records={pageState.usages} >
            <Column caption="شرح قلم مصرفی" type={ColumnType.DisplayValue} columnName="stuffName" ></Column>
            <Column caption="مقدار" type={  ColumnType.InputFloat  } columnName="amount" ></Column>
        </ProTable>
 

    </FromSubmit>
}






export class AddDelevryUsage extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
        this.state = { items: [], isLoaded: false };
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        
        h.Ajax('DelevryUsage', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, items: window.usage , id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
         
        h.Ajax('DelevryUsage', 'Get', { id: this.id }, function (data) {
            if (cmd.id != -1) {
                h.SetDataBack(data.model);
                   }
            cmd.setState({ items: data.usageAmounts });
            window.usage = data.usageAmounts
            });
        



    }
 
    render() {
        return <FromSubmit submitBev={this.submit}>
          
            <InputBox meta={DataClass.DelevryUsage.UserId} size='33%' />
            
            <InputBox meta={DataClass.DelevryUsage.MoveTime} size='33%' />
            <InputBox meta={DataClass.DelevryUsage.MoveType} size='33%' />
            <InputBox meta={DataClass.DelevryUsage.Descr} size='100%' />
            <ProTable datasourcename="usage" Records={this.state.items} >
                <Column caption="شرح قلم مصرفی" type={ColumnType.DisplayValue} columnName="stuffName" ></Column>
                <Column caption="مقدار" type={ColumnType.InputFloat} columnName="amount" ></Column>
            </ProTable>
        

        </FromSubmit>

    }

}


function EditDelevryUsage() {
    const queryS = useParams();
    return <AddDelevryUsage id={queryS.id} />
}
const ContactType = { admin: 1, installer: 2, fiojanr: 3 ,fixer:4 }
function MyActiveMission(props = { type: ContactType.admin }) {
    let status = -1;
    let params = useParams();
    if (params.status != undefined) {

        status = params.status;
         
    }

    const [pageState, setState] = useState({ records: [], isLoaded: false, type: props.type });
    const Load = (all) => {
        let h = new Helper();
        let actionName = 'ListAll';
        if (props.type == ContactType.installer) {
            actionName = 'ListForInstall';
        }
        if (props.type == ContactType.fiojanr) {
            actionName = 'ListForFiojan';
        }
        if (props.type == ContactType.fixer) {
            actionName = 'ListForFixer';
        }
        h.Ajax('Mission', actionName, { containAll: all }, (data) => {
            let rec = data;
            if (status >= 0) {
                rec = h.GetRecordWithCircita(rec, 'status', status)
            }

            setState({ records: rec, isLoaded: true, type: props.type });
        });

    }
    const OnlyWarring = (all) => {
        let h = new Helper();
        let actionName = 'ListAll';
        if (props.type == ContactType.installer) {
            actionName = 'ListForInstall';
        }
        if (props.type == ContactType.fiojanr) {
            actionName = 'ListForFiojan';
        }
        h.Ajax('Mission', 'Warring', { containAll: all }, (data) => {
            let rec = data;
            if (status >= 0) {
                rec = h.GetRecordWithCircita(rec, 'status', status)
            }

            setState({ records: rec, isLoaded: true, type: props.type });
        });

    }
    const OnlyUnPayed = (all) => {
        let h = new Helper();
        
        h.Ajax('Mission', 'UnPayed', { containAll: all }, (data) => {
            let rec = data;
            if (status >= 0) {
                rec = h.GetRecordWithCircita(rec, 'status', status)
            }

            setState({ records: rec, isLoaded: true, type: props.type });
        });

    }
    const Delete = (rec) => {
        let hlp = new Helper();
         
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Mission', 'Delete', { id: rec.id }, function (data) {
                Load();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    };
    const Cancel = (rec) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Mission', 'Cancel', { id: rec.id }, function (data) {
                Load();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    };
    
    const AlertMission = (rec) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Mission', 'AlertMission', { id: rec.id }, function (data) {
          
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    };
    if (pageState.isLoaded == false || pageState.type != props.type) {
        
        
        if (status == "-2") {
            OnlyUnPayed(true);
        }
        else if (status == "-3") {
            OnlyWarring(true);
        }
        else if (status == "-5") {
            Load(true);
        }
        else {
            Load();
        }
        return <LoadingBar />
        }
        
     
    

    return <FromBasic>
      



        <center size="33%">
            {props.type == ContactType.fixer && <center>
                <h3>کارتابل رفع خرابی</h3>
            </center>}
            {props.type == ContactType.fiojanr && <center>
                <h3>در انتظار فیوژن کار</h3>
            </center>}
            {props.type == ContactType.installer && <center>
                <h3>در انتظار سیم کش</h3>
            </center>}
            {props.type == ContactType.admin &&
                <span>
                    <Link to="/Admin/NewMission">
                        <SimpleButton title="جدید" Icon="New"></SimpleButton>
                    </Link>
                    <SimpleButton title="جاری" onClick={() => { Load(false); }}></SimpleButton>
                    <SimpleButton title="همه موارد" onClick={() => { Load(true); }}></SimpleButton>
                    <SimpleButton title="موارد اخطار" onClick={() => { OnlyWarring(true); }}></SimpleButton>
                    <SimpleButton title="پرداخت نشده ها" onClick={() => { OnlyUnPayed(true); }}></SimpleButton>

                </span>}
                </center>
       
        <ProTable rowNumbering={true} key={new Date().toString() } rowFormating={(x) => {
            if (x.proitityType == 1) {
                if (x.status != 2) {
                    return 'bgOrange';
                }
              
            }
            if (x.proitityType == 2) {
                if (x.status != 2) {
                    return 'bgHigh';
                }

            }

        }} Records={pageState.records} key={new Date().toString()} datasourcename="missions" >
          
            <Column metaForDisplay={DataClass.ServiceMission.FullName} />
            <Column metaForDisplay={DataClass.ServiceMission.Address} />
            <Column metaForDisplay={DataClass.ServiceMission.Mobile} />
            {props.type == ContactType.admin &&
                <Column metaForDisplay={DataClass.ServiceMission.Status} />

            }
            {props.type == 1 &&
                <Column metaForDisplay={DataClass.ServiceMission.CurrentUser} />

            }
            {status == -5 &&
                <Column metaForDisplay={DataClass.ServiceMission.InstallerUserId} />

            }
            {status == -5 &&
                <Column metaForDisplay={DataClass.ServiceMission.FiojanerUserId} />

            }
            {status == -5 &&
                <Column metaForDisplay={DataClass.ServiceMission.FixerUserId} />

            }
            <Column metaForDisplay={DataClass.ServiceMission.ReachTime} />
            <Column metaForDisplay={DataClass.ServiceMission.ProitityType} />
            {props.type == 1 &&
                <Action caption={"اصلاح "} type="Link" showCond={(r) => {
                return r.status != 2;

            }} pageName={"/EditJob"} columnName="id" />
            }
            {props.type == 1 &&
                <Column metaForDisplay={DataClass.ServiceMission.Payed} />

            }
            {props.type == 1 &&
                <Action caption="اصلاح اقلام مصرفی-سیم کش" type="Link" pageName={"/EditJobUsage/2"} columnName="id" />

            }
            {props.type == 1 &&
                <Action caption="اصلاح اقلام مصرفی-فیبربان" type="Link" pageName={"/EditJobUsage/4"} columnName="id" />

            }
            {props.type == 1 &&
                <Action caption="اصلاح فاکتور" type="Link" pageName={"/Sell/Edit"} columnName="orderId" />

            }
            {props.type == 1 &&
                <Action caption="ثبت نحوه پرداخت" type="Link" pageName={"/Sell/SetPayInfo"} columnName="orderId" />

            }
            {props.type == 1 &&
                <Action caption="اصلاح اقلام مصرفی-فیوژن کار" type="Link" pageName={"/EditJobUsage/3"} columnName="id" />

            }
            {props.type == 1 &&
                <Action caption="هشدار" type="function" targetFun={AlertMission} />

            }

            {props.type == 1 &&
                <Action caption="حذف" type="function" targetFun={Delete} />

            }
            {props.type == 1 &&
                <Action caption="انصراف" type="function" targetFun={Cancel} />

            }
            {props.type == ContactType.installer &&
                <Column metaForDisplay={DataClass.ServiceMission.DescrForInstaller} />

            }
            {props.type == ContactType.fiojanr &&
                <Column metaForDisplay={DataClass.ServiceMission.DescrForFijaner} />

            }
            {props.type == ContactType.fixer &&
                <Column metaForDisplay={DataClass.ServiceMission.DescrForFixer} />

            }
            <Action caption={props.type == 1 ? "مشاهده " : "ثبت پاسخ"} type="Link" pageName={"/DoneJob/" + props.type} columnName="id" />
        
        </ProTable>
    </FromBasic>

}


function SetAnwser(props) {
    let params = useParams();
    let id = params.id;
    let type = params.type;
    let editMode = props.editMode;
    if (editMode == undefined) {

    }
  
    const [pageState, setState] = useState({ items: [], isLoaded: false });

    const load = () => {
        let h = new Helper();
        

        h.Ajax('Mission', 'Get', { id: id ,type:type }, function (data) {
            
                h.SetDataBack(data.model);

            setState({ items: data.items, isLoaded: true });
            window.usage = data.items
        });

    };
    const submit = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            let actionName = 'InstallModem'
            if (type == 3) {
                actionName = 'FiojanModem';
            }
            if (type == 4) {
                actionName = 'FixMission';
            }
            if (editMode == true) {
                actionName ="UpdateUsage"
            }


            h.Ajax('Mission', actionName, { type: type, id: id, usages: window.usage, result: $('#txtResult').val(), problemSide: $('#txtProblemSide').val() },
                (data) => {
                    h.Alert(data.message);
                    if (data.status == '200') {
                        h.GoBack();
                    }


                }
             
            )

        }

    };


    if (pageState.isLoaded == false) {
        load();
    }
    const backToInstall = () => {
        let h = new Helper();
        h.ConfirmAction('آیا به سیم کش ارجاع شود؟', 'پرسش',

            () => {
                h.Ajax('Mission', 'SendBackToInstaller', { id: id, descr: $('#txtDescrFijaner').val()}
                    , (data) => {
                        h.Alert(data.message);
                        if (data.status == '200') {
                            h.GoBack();
                        }
                    });
            }

        )


    }
    const failJob = () => {
        let h = new Helper();
        h.ConfirmAction('تیکت مورد نظر ناموفق می شود آیا ادامه می دهید ', 'پرسش',

            () => {
                h.Ajax('Mission', 'FailFix', { id: id, result: $('#txtResult').val() }
                    , (data) => {
                        h.Alert(data.message);
                        if (data.status == '200') {
                            h.GoBack();
                        }
                    });
            }

        )

    }


    return <FromSubmit submitBev={submit} hideButton={type==1}>
        <InputBox meta={DataClass.ServiceMission.FullName} size="50%" disabled="yes" />
         <InputBox meta={DataClass.ServiceMission.Mobile} size="50%" disabled="yes" />
        <InputBox meta={DataClass.ServiceMission.Address} size="100%" disabled="yes" />

        {type == ContactType.installer &&
            <InputBox meta={DataClass.ServiceMission.DescrInstaller} size='100%'  />    
        }
        {type == ContactType.installer &&
            <InputBox meta={DataClass.ServiceMission.DescrFijaner} disabled="yes"  size='100%' />
        }
        {type == ContactType.fiojanr &&
            <InputBox meta={DataClass.ServiceMission.DescrInstaller} disabled="yes" size='100%' />
        }
        {type == ContactType.fiojanr &&
            <InputBox meta={DataClass.ServiceMission.DescrForFijaner} disabled="yes" size='100%' />
        }
        {type == ContactType.installer &&
            <InputBox meta={DataClass.ServiceMission.DescrForInstaller} disabled="yes" size='100%' />
        }
        {type == ContactType.fixer &&
            <InputBox meta={DataClass.ServiceMission.DescrForFixer} disabled="yes" size='100%' />
        }

        {type == ContactType.fiojanr &&

            <InputBox meta={DataClass.ServiceMission.DescrFijaner} size='100%' />
        }

  
   
        <ProTable datasourcename="usage" Records={pageState.items} >
            <Column caption="شرح قلم مصرفی" type={ColumnType.DisplayValue} columnName="stuffName" ></Column>
            <Column caption="مقدار" type={type != 1 ? ColumnType.InputFloat : ColumnType.DisplayValue} columnName="amount" ></Column>
        </ProTable>
        
            <center>
            {type == ContactType.fixer &&

                <InputBox meta={DataClass.Ticket.Result} size='100%' />
            }
            {type == 3 &&
                <Link to={"/Admin/ICanDo/" + id } >
                    <SimpleButton Icon="No" title='نیاز به سیم کش می باشد'></SimpleButton>
                </Link>
            }
            {type == ContactType.fixer &&
                <span>
                <br/>
                    این گزینه زمانی استفاده کنید که هیچ گونه اقدامی بروی این ماموریت انجام انجام ندادید
                    <SimpleButton Icon="No" onClick={() => { failJob(); } } title='نتوانستم هیچ اقدام روی اینکار انجام بدهم'></SimpleButton>
                </span>
              
            }


        </center>
        
        

    </FromSubmit>

}






function ReportCurrentStorages(props) {
    const [pageState, loadState] = useState({ records: [], isLoaded: false });
    let isMe = false
    if (props.isMe != undefined) {
        isMe = true;
    }

    const load = () => {
        let h = new Helper();
        h.Ajax('ModemSerivce', isMe ?'ReportForMe': 'Report', {}, (data) => {
            loadState({ records: data, isLoaded: true });
        });

    };

    if (pageState.isLoaded == false) {
        load();
        return <LoadingBar />;
    }

    return <FromBasic>
        <SideView>
            {pageState.records.map((v) => {
                return <SideItem id={v.userName} title={v.fullName}>
                    <ProTable Records={v.usageAmount} datasourcename={v.userName}>
                        <Column type={ColumnType.DisplayValue} caption="قلم مصرفی" columnName="stuffName"/>
                        <Column type={ColumnType.DisplayValue} caption="میزان مصرفی" columnName="amount" />
                    </ProTable>
                </SideItem>

            })}
        </SideView>

    </FromBasic>

}


function ReportCurrentTiming(props) {
    const [pageState, loadState] = useState({ records: [], isLoaded: false });
    let isMe = false
    if (props.isMe != undefined) {
        isMe = true;
    }

    const load = () => {
        let h = new Helper();
        h.Ajax('ModemSerivce', isMe ? 'ReportServiceManTimingForMe' : 'ReportServiceManTiming', h.GetPostData(), (data) => {
            loadState({ records: data, isLoaded: true });
        });

    };
    const timeInfo = (v,title) => {
        return <span><h4>{title}</h4> <br></br> تعداد انجام شده:{v.count} بیشترین زمان:{v.max} کمترین:{v.min} میانگین:{v.avg } </span>

    }
    

    return <FromBasic>
        <InputTextBox caption="از تاریخ" size='50%' customHelper={CustomHelper.isDate} model="from" columnName="from" mustFill="yes" />
        <InputTextBox caption="تا تاریخ" size='50%' customHelper={CustomHelper.isDate} model="to" columnName="to" mustFill="yes" />
        <SimpleButton title="نمایش " Icon="View" onClick={load}></SimpleButton>

        


        <SideView>
            {pageState.records.map((v) => {
                return <SideItem id={v.userId} title={v.userFullName}>
                    {timeInfo(v.installResult, 'سیم کشی')} 
                    <br />
                    {timeInfo(v.fiojanResult, 'فیوژن')} 
                    <br />
                    {timeInfo(v.fixResult, 'رفع عیب')}
                    <br />
                    کلیه ماموریت های انجام شده :
                    <ProTable datasourcename={'detail' + v.userId } Records={v.missions}>
                        <Column metaForDisplay={DataClass.OperationTime.UserServiceType} />
                        <Column metaForDisplay={DataClass.OperationTime.CustomerName} />
                        <Column metaForDisplay={DataClass.OperationTime.CustomerMobile} />
                        <Column metaForDisplay={DataClass.OperationTime.ProitityType} />
                        <Column caption="به ساعت" type={ColumnType.FunctionValue} customFunction={(v) => { return Math.floor(parseFloat(v.timeTaken)); }} />
                        <Column caption="به شرح" type={ColumnType.FunctionValue} customFunction={(v) => {
                            if (v.timeTaken < 1) {
                                return "کمتر از یک ساعت";
                            }
                            if (v.timeTaken > 24) {
                                return Math.floor(v.timeTaken / 24) + " روز ";
                            }
                            else {
                                return Math.floor(parseFloat(v.timeTaken)) + " ساعت";
                            }
          
                        }} />

                    </ProTable>


                </SideItem>

            })}
        </SideView>

    </FromBasic>

}

function CreateDocAuto(props) {
    const [pageState, loadState] = useState({ records:window.currentUsages });
    const submit = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = { model: h.GetPostData(), usages: window.currentUsages };
        
        h.Ajax('Mission', 'CreateAutoDoc', data, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    };

    return <FromSubmit submitBev={submit}>
        <InputBox meta={DataClass.FinEvent.EventDate} size='33%' />
        <InputBox meta={DataClass.FinEvent.PersonId} size='33%' />
        <InputBox meta={DataClass.FinEvent.EventTypeId} size='33%' />
        <InputBox meta={DataClass.FinEvent.Descr} size='100%' />
      
        <ProTable Records={window.currentUsages} afterChange={
            (d, v, r, colName) => {
                d[r].totalPrice = d[r].amount * d[r].unitPrice;
            }
        } datasourcename={'currentUsages'}>
        <Column type={ColumnType.DisplayValue} caption="قلم مصرفی" columnName="stuffName" />
            <Column type={ColumnType.DisplayValue} caption="میزان مصرفی" columnName="amount" />
            <Column type={ColumnType.InputNumberDigited} caption="فی" columnName="unitPrice" onchange={(r) => {
               
            }} />
            <Column type={ColumnType.DisplayDigidGrouped} caption="جمع" columnName="totalPrice" />
           
        </ProTable>
    </FromSubmit>
}


function ReportUsages(props) {
    const [pageState, loadState] = useState({ detailRecords: [], byCustomerPovit: { data: {}, columns: {} }, records: [], isLoaded: false, povitData: { data: {}, columns: {} } });
    let isMe = false
    if (props.isMe != undefined) {
        isMe = true;
    }

    const load = () => {
        let h = new Helper();
        h.Ajax('ModemSerivce', isMe ?'ReportUsageForMe':'ReportUsage', h.GetPostData(), (data) => {
            loadState({ detailRecords: pageState.detailRecords, povitData: pageState.povitData, byCustomerPovit: pageState.byCustomerPovit, records: data, isLoaded: true });
        });

    };
    const loadDetail = () => {
        let h = new Helper();
        h.Ajax('ModemSerivce', isMe ? 'ReportUsageDetailForMe':  'ReportUsageDetail', h.GetPostData(), (data) => {
            let povit = h.createPivot(data.detail, ["serviceWorkerName", "customerTitle", "customerMobile", "customerAddress", "usage"], "usageStuffTitle", "amount");
            let povitCustomer = h.createPivot(data.detail, [  "customerTitle", "customerMobile", "customerAddress" ], "usageStuffTitle", "amount");

            loadState({ records: pageState.records, detailRecords: data.detail, povitData: povit, byCustomerPovit: povitCustomer, isLoaded: true });
             
        });

    };
    const routing = useNavigate();

    return <FromBasic>
         <Link id="documentCreate" to="/Admin/CreateDoc"></Link>
       
        <InputTextBox caption="از تاریخ"  size='50%'customHelper={CustomHelper.isDate} model="from" columnName="from" mustFill="yes" />
        <InputTextBox caption="تا تاریخ" size='50%' customHelper={CustomHelper.isDate} model="to" columnName="to" mustFill="yes" />
        <center>
            <SimpleButton title="نمایش به صورت کل " Icon="View" onClick={load}></SimpleButton>
            <SimpleButton title="نمایش به صورت ریز " Icon="View" onClick={loadDetail}></SimpleButton>

        </center>
         <SideView>
            {pageState.records.map((v) => {
                return <SideItem id={v.userName} title={v.fullName}>
                    {isMe == false && <SimpleButton title="ایجاد رویداد مالی مرتبط" onClick={() => {
                        window.currentUsages = v.usageAmount;

                        routing("/Admin/CreateDoc")

                    }}></SimpleButton>}
                    <ProTable Records={v.usageAmount} datasourcename={v.userName}>
                        <Column type={ColumnType.DisplayValue} caption="قلم مصرفی" columnName="stuffName" />
                        <Column type={ColumnType.DisplayValue} caption="میزان مصرفی" columnName="amount" />
                    </ProTable>
                </SideItem>

            })}
        </SideView>
        <br/>
        گزارش  محور به صورت تفکیک مشترک
        <ProTable povitColumns={pageState.byCustomerPovit.columns} datasourcename="PovitReport2" Records={pageState.byCustomerPovit.data}>
             
            <Column metaForDisplay={DataClass.UsageDetailDto.CustomerTitle} ></Column>
            <Column metaForDisplay={DataClass.UsageDetailDto.CustomerMobile} ></Column>
            <Column metaForDisplay={DataClass.UsageDetailDto.CustomerAddress} ></Column>
        </ProTable>



        
        <br />
        گزارش به صورت محوری
        <br />
        <ProTable povitColumns={pageState.povitData.columns} datasourcename="PovitReport" Records={pageState.povitData.data}>
            <Column metaForDisplay={DataClass.UsageDetailDto.ServiceWorkerName} ></Column>
            <Column metaForDisplay={DataClass.UsageDetailDto.Usage} ></Column>
           
            <Column metaForDisplay={DataClass.UsageDetailDto.CustomerTitle} ></Column>
            <Column metaForDisplay={DataClass.UsageDetailDto.CustomerMobile} ></Column>
            <Column metaForDisplay={DataClass.UsageDetailDto.CustomerAddress} ></Column>
        </ProTable>



        <br />
         گزارش به صورت تفصیلی 
        <br />
        <ProTable datasourcename="detail" Records={pageState.detailRecords}>
            <Column metaForDisplay={DataClass.UsageDetailDto.ServiceWorkerName} ></Column>
            <Column metaForDisplay={DataClass.UsageDetailDto.Usage} ></Column> 
            <Column metaForDisplay={DataClass.UsageDetailDto.ProitityType} ></Column>
            <Column metaForDisplay={DataClass.UsageDetailDto.CustomerTitle} ></Column>
            <Column metaForDisplay={DataClass.UsageDetailDto.CustomerMobile} ></Column>
            <Column metaForDisplay={DataClass.UsageDetailDto.CustomerAddress} ></Column>

        <Column metaForDisplay={DataClass.UsageDetailDto.UsageStuffTitle} ></Column>
        <Column metaForDisplay={DataClass.UsageDetailDto.UsageTime} ></Column>
        <Column metaForDisplay={DataClass.UsageDetailDto.Amount} ></Column> 

        </ProTable>

    </FromBasic>

}
///ICanDo/


export class AddFTTHRequest extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('FTTHRequest', ('Insert'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                $('#txtFristName').val('');
                $('#txtLastName').val('');
                $('#txtAddress').val('');
                $('#txtMobile').val('');
                $('#txtPostCode').val('');
                $('#txtPhoneNumber').val('');
                $('#txtNatId').val('');
                $('#txtFatherName').val('');
                $('#txtLedId').val('');
                $('#txtBrithDate').val('');
                $('#txtlocation').val('');
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }


    getCurrentLocation() {
        if (!navigator.geolocation) {
            console.log("Geolocation is not supported by this browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            function (position) {
                const lat = position.coords.latitude;
                const lon = position.coords.longitude;

                console.log("Latitude:", lat);
                console.log("Longitude:", lon);

                $('#txtlocation').val(lat + "," + lon);
            },
            function (error) {
                console.error("Error getting location:", error.message);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    }
    pickFromMap() {
        let wi = window.open("/FTTHBox/EditMap?loc=" + $('#txtlocation').val());
        wi.targetFun = (p) => { $('#txtlocation').val(p); };
    }
    componentDidMount() {
       
        setTimeout(() => { this.getCurrentLocation(); }, 1000);
    }
    render() {
        return <FromSubmit submitBev={this.submit}>

            <InputBox meta={DataClass.FTTHRequest.FristName} size='33%' />
            <InputBox meta={DataClass.FTTHRequest.LastName} size='33%' />
            <InputBox meta={DataClass.FTTHRequest.Mobile} size='33%' />

            <InputBox meta={DataClass.FTTHRequest.Address} size='100%' />
            <InputBox meta={DataClass.FTTHRequest.PostCode} size='33%' />
            <InputBox meta={DataClass.FTTHRequest.PhoneNumber} size='33%' />
            <InputBox meta={DataClass.FTTHRequest.NatId} size='33%' />
            <InputBox meta={DataClass.FTTHRequest.FatherName} size='25%' />
            <InputBox meta={DataClass.FTTHRequest.LetId} size='25%' />
            <InputBox meta={DataClass.FTTHRequest.BrithDate} size='25%' />
            <InputBox meta={DataClass.FTTHRequest.location} size='25%' />
            <SimpleButton title="دریافت مکان از gps" onClick={this.getCurrentLocation}></SimpleButton>
            {this.props.useMode == undefined &&
                <SimpleButton title="انتخاب از نقشه" onClick={this.pickFromMap}></SimpleButton>
            }
        </FromSubmit>

    }

}
export class FTTHRequestMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.CantDoIt = this.CantDoIt.bind(this);
        this.Restore = this.Restore.bind(this);
        this.Refersh = this.Refersh.bind(this);
        this.Delete = this.Delete.bind(this);
        this.mode = this.props.archvieMode == true ? "all" : "inprogress";
    }

    CantDoIt(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('FTTHRequest', 'CantRun', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('FTTHRequest', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    Restore(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('FTTHRequest', 'Restore', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('FTTHRequest', this.mode == 'all' ? 'List' : 'InProgress', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }
    getNearest() {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('FTTHRequest', 'CalcNeareast', {}, function (data) {
                cmd.Refersh();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <center>
                    <Link to="/Admin/FTTHRequest/New"><SimpleButton Icon="New" title="ثبت نام جدید"></SimpleButton></Link>
                    <Link to="/Admin/FTTHRequestInbox"><SimpleButton Icon="DateTime" title="جاری"></SimpleButton></Link>

                    <Link to="/Admin/FTTHRequestArchive"><SimpleButton Icon="Database" title="آرشیو"></SimpleButton></Link>
                    <SimpleButton title="محاسبه نزدیک ترین باکس" onClick={this.getNearest }> </SimpleButton>
                </center>


                <ProTable Records={this.state.Records} datasourcename='FTTHRequests'>
                    <Column metaForDisplay={DataClass.FTTHRequest.id} />
                    <Column metaForDisplay={DataClass.FTTHRequest.FullName} />
                    <Column metaForDisplay={DataClass.FTTHRequest.FatherName} />
                    <Column metaForDisplay={DataClass.FTTHRequest.BrithDate} />
                    <Column metaForDisplay={DataClass.FTTHRequest.LetId} />
                    <Column metaForDisplay={DataClass.FTTHRequest.Address} />
                    <Column metaForDisplay={DataClass.FTTHRequest.Mobile} />
                    <Column metaForDisplay={DataClass.FTTHRequest.PostCode} />
                    <Column metaForDisplay={DataClass.FTTHRequest.NatId} />
                    <Column metaForDisplay={DataClass.FTTHRequest.StaticStatus} />
                    <Column metaForDisplay={DataClass.FTTHRequest.UserNameCreated} />
                    <Column metaForDisplay={DataClass.FTTHRequest.CreateTime} />


                    {this.mode == 'all' &&
                        <Column metaForDisplay={DataClass.FTTHRequest.Status} />
                    }
                 
                    
                    {this.mode != 'all' &&
                        <Action caption="تایید و ایجاد فاکتور خدمات" type="Link" pageName="/FTTHRequest/Confrim" columnName="id" />
                    }
                  
                    {this.mode != 'all' &&
                        <Action caption="عدم امکان" type="function" targetFun={this.CantDoIt} />
                    }
                    {this.mode == 'all' &&
                        <Action caption="بازگردانی" type="function" targetFun={this.Restore} />
                    }
                    {this.mode != 'all' &&
                        <Action caption="حذف" type="function" targetFun={this.Delete} />
                    }
                    {this.mode != 'all' &&
                        <Action caption="مشاهده مکان و امکان سنجی از طریق gps" type="function" targetFun={(r) => {
                        window.open('/FTTHBox/ShowMap?loc=' + r.location);
                        }} />

                    }
                 
                        <Action caption="اصلاح مکان" type="function" targetFun={(r) => {
                        var w = window.open('/FTTHBox/EditMap?loc=' + r.location);
                        window.id = r.id;
                        w.targetFun = (p) => {
                            let h = new Helper();
                            h.Ajax('FTTHRequest', 'UpdateLocation', { id: window.id, location: p }
                                , (data) => {
                                    h.MessageBox(data.message);

                                }
                            )

                        };
                        }} />

                   
                </ProTable>
            </FromBasic>
        }
    }
}



function EditFTTHRequestAnswer() {
    const queryS = useParams();
    return <AddFTTHRequestAnswer id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddFTTHRequestAnswer extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.state = { Records: [] };
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();

        h.Ajax('FTTHRequest', 'SetAnswer', { Model: o, id: id, items: window.OrderItems }, function (data) {
            if (data.status == 200) {

                h.ConfirmAction("ثبت گردید آیا تعیین تکلیف مالی باز گردد", "", () => {
                    window.open("/Admin/Sell/SetPayInfo/" + data.refId);

                });
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('FTTHRequest', 'LoadData', { id: this.id }, function (data) {
                h.SetDataBack(data.model);
                $('#txtUnitPrice').val(data.unitPrice);
            });


        }
    }

    onChange(dataSource, newValue, index, ColName) {
        let cmd = this;
        const calcPrice = () => {
            let h = new Helper();
            dataSource[index]['totalPrice'] = dataSource[index]['unitPrice'] * dataSource[index]['count'];
            //cmd.setTotalFactor();
        }
        if ((ColName == 'productId') || (ColName == 'needGranty')) {
            let h = new Helper();
            h.Ajax('Product', 'Get', { id: dataSource[index]['productId'] },
                (data) => {
                    data = data.model;
                    if (data.productType != 0) {
                        dataSource[index]['needGranty'] = false;
                    }
                    if ((ColName == 'productId')) {
                        if (data.productType == 0) {
                            dataSource[index]['needGranty'] = true;
                        }
                    }

                    let needGranty = dataSource[index]['needGranty'];

                    if (ColName == 'productId') {
                        dataSource[index]['unitPrice'] = data.priceInRail + (needGranty == true ? data.granty : 0) -data.discount;
                    }
                    else {
                        dataSource[index]['unitPrice'] = needGranty == true ? dataSource[index]['unitPrice'] + data.granty : dataSource[index]['unitPrice'] - data.granty;
                    }

                    calcPrice();
                    window.OrderItems = dataSource;
                    cmd.setState({ isLoaded: true, Records: window.OrderItems });

                }


            );
        }

        if (ColName == 'unitPrice') {
            calcPrice();
        }
        if (ColName == 'count') {
            calcPrice();
        }
    }

     



    render() {
        let newDate = new Date();
        newDate.setFullYear(newDate.getFullYear() + 1);
        return <FromSubmit submitBev={this.submit}>
           
            <InputBox meta={DataClass.FTTHRequest.FullName} size='50%' />

            <InputBox meta={DataClass.FTTHRequest.Mobile} size='50%' />

            <InputBox meta={DataClass.FTTHRequest.Address} size='100%' />
            <InputBox meta={DataClass.FTTHRequest.PostCode} size='33%' />
          
            <InputBox meta={DataClass.FTTHRequest.NatId} size='33%' />
            <InputBox meta={DataClass.FTTHRequest.FatherName} size='33%' />
            <InputBox meta={DataClass.FTTHRequest.LetId} size='33%' />
            <InputBox meta={DataClass.FTTHRequest.BrithDate} size='33%' />
            <InputBox meta={DataClass.FTTHRequestAnswer.UnitPrice} size='33%' />
              
            <InputBox meta={DataClass.FTTHRequestAnswer.InstallerUserId} size='33%' />

            <InputBox meta={DataClass.FTTHRequestAnswer.FiojanerUserId} size='33%' />
            

            <FormDiv size="100%"> سایر اقلام فاکتور (هزینه سیم کشی درج نگردد) </FormDiv>
          


            <ProTable rowNumbering={true} afterChange={this.onChange} datasourcename='OrderItems' Records={this.state.Records} Insertable={true} Deleteable={true}>
                <NewRecordValue columnName="startGranteyDate" newValue={new Helper().MilToPer(new Date())}></NewRecordValue>
                <NewRecordValue columnName="endGranteyDate" newValue={
                    new Helper().MilToPer(newDate)
                }></NewRecordValue>
                <NewRecordValue columnName="needGranty" newValue={
                    true
                }></NewRecordValue>
                <NewRecordValue columnName="count" newValue={1}></NewRecordValue>
                <Column type={ColumnType.InputCheck} columnName="needGranty" caption="شامل گارانتی" titleColumnName='productName' />
                <Column metaForInput={DataClass.OrderItem.ProductId} titleColumnName='productName' />
                <Column metaForInput={DataClass.OrderItem.UnitPrice} />
                <Column metaForInput={DataClass.OrderItem.Count} />

                <Column metaForDisplay={DataClass.OrderItem.TotalPrice} />

              
                 

            </ProTable>



        </FromSubmit>

    }

}

export class AddTicket extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Ticket', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != undefined) {
            h.Ajax('Ticket', 'Get', { id: this.id, type: 1 }, function (data) {

                h.SetDataBack(data);



            });
        }

  
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
            {this.id == "-1" &&
                <InputBox meta={DataClass.Ticket.FullName} size='25%' />
            }
           
                <InputBox meta={DataClass.Ticket.Mobile} size='25%' />
          
        
            <InputBox meta={DataClass.Ticket.ProblemTitle} size={this.id == "-1" ? '25%' : '100%'} />
           
                <DropDownBox caption="فیبربان" columnName="fixerUserId" entity="FixerUser" mustFill={true} size='25%' />
             
            <InputBox meta={DataClass.Ticket.Address} size='100%' />

            <InputBox meta={DataClass.Ticket.DescrForFixer} size='100%' />

        </FromSubmit>

    }

}
function TicketSerach(props) {

   
    const [pageState, setData] = useState({ keyx: '', records: [], isLoaded: false, filter: '', pageTemplate: [], templateId: -1 });
    const [groupState, setGroup] = useState({ grouped: [], isLoaded: false, unpayed: -1 });


    const serach = () => {
        let h = new Helper();
       
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Ticket', 'Serach', data, (data) => {
            setData({ records: data, isLoaded: true, keyx: new Date().toString(), filter: '' , pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };

    const Cancel = (record) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Ticket', 'Cancel', { id: record.id }, function (data) {
                inprogress();
                hlp.MessageBox(data.message, FixedMessage.Result);
               
            });
        });
    };
    const ReturnToFixer = (record) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Ticket', 'ReturnToFixer', { id: record.id }, function (data) {
                inprogress();
                hlp.MessageBox(data.message, FixedMessage.Result);

            });
        });
    };
    const closed = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Ticket', 'Closed', {  }, (data) => {
            setData({ records: data, isLoaded: true, keyx: new Date().toString(), filter: '',   pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });
              setTimeout(() => { getGrouped() }, 500 );
        });
    };
    const inprogress = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Ticket', 'InPrgoress', {}, (data) => {
            setData({ records: data, isLoaded: true, keyx: new Date().toString(), filter: '',   pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });
            setTimeout(() => { getGrouped() }, 500);
        });
    };
    const Refersh = (status) => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Ticket', 'List', { status: status }, (data) => {
            setData({ records: data, isLoaded: true, keyx: new Date().toString(), filter: '',  pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });
           
        });


    }
    const unPayed = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Ticket', 'UnPayed', {}, (data) => {
            setData({ records: data, isLoaded: true, keyx: new Date().toString(), filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });
           
        });
    };
    const ReadyForFactor = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Ticket', 'ReadyForFactor', {}, (data) => {
            setData({ records: data, isLoaded: true, keyx: new Date().toString(), filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };
    const isAdmin = () => {
        if (window.shareInfo == undefined) {
            return false;
        }
        return window.shareInfo.per.indexOf("CreateOrderFixMission") != -1;
    };
    const getGrouped = () => {

        let h = new Helper();
     
     
        h.Ajax('Ticket', 'Grouped', {}, (data) => {
            window.keyx = new Date().toString();
            setGroup({ grouped: data.grouped,unpayed:data.unPayed ,isLoaded:true });
        });


    };

    if (props.mode == undefined) {
        if (pageState.isLoaded == false) {
            inprogress();
           
        }
    }
    else {
        if (pageState.isLoaded == false) {
            if (props.mode == 'UnPayed') {
                unPayed();
            }
            if (props.mode == 'ReadyForFactor') {
                ReadyForFactor();
            }

            setTimeout(() => { getGrouped() }, 500);  
        }
    }

    let h = new Helper();
    return <FromBasic >

        <div id="moreSerach" style={{ display:'none' }}>
            <FromBasic>
            <InputTextBox caption="نام" columnName="fullName" model="fullName" size="33%"></InputTextBox>

            <InputTextBox caption="موبایل" columnName="mobile" model="mobile" size="33%"></InputTextBox>
            <InputTextBox caption="عنوان مشکل" columnName="problemTitle" model="problemTitle" size="33%"></InputTextBox>

            <InputTextBox caption="از تاریخ" columnName="StartDate" model="StartDate" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
            <InputTextBox caption="تا تاریخ" columnName="EndDate" model="EndDate" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
            <center>
                <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
                </center>
                </FromBasic> 
        </div>
        <center  >
            <AddButton title='' entity='Ticket' />
            {groupState.isLoaded == true && isAdmin()  &&
                <span key={new Date().toString()}>
                    {groupState.grouped.map((v) => {
                       
                        return <SimpleButton title={h.GetCaptionFromEnum(enums.TicketStatus, v.status) + "(" + v.count + ")"}
                            onClick={() => { Refersh(v.status) }}
                        ></SimpleButton>
                    })}
                </span>}
           
            <SimpleButton onClick={() => {
                $('#moreSerach').toggle(500);

            }} title="جستجو پیشرفته" Icon="Database"></SimpleButton>
            {isAdmin()==false &&
                <SimpleButton onClick={() => {
                    inprogress();

                }} title={"در جریان"} ></SimpleButton>}
            {isAdmin()==false &&
                <SimpleButton onClick={() => {
                    closed();

                }} title={"مختومه"} ></SimpleButton>}
            {  window.shareInfo != null &&  isAdmin()  &&
                <SimpleButton onClick={() => {
                    unPayed();

                }} title={"پرداخت نشده(" + (groupState.unpayed) + ")"} Icon="Cash"></SimpleButton>}
        </center>

        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="records" key={Date().toString()} Records={pageState.records}>
                <Column metaForDisplay={DataClass.Ticket.Id} />
                <Column metaForDisplay={DataClass.Ticket.FullName} />
                <Column metaForDisplay={DataClass.Ticket.Address} />
                <Column metaForDisplay={DataClass.Ticket.FixerUserCaption} />
                <Column metaForDisplay={DataClass.Ticket.ProblemTitle} />
                <Column metaForDisplay={DataClass.Ticket.Mobile} />
                <Column metaForDisplay={DataClass.Ticket.Result} />
                {isAdmin() && <Column metaForDisplay={DataClass.Ticket.Status} />}
                {isAdmin() == false && <Column type={ColumnType.FunctionValue} caption="وضعیت"
                    customFunction={(r) => {
                        if (r.status == 0) {
                            return "در حال بررسی";
                        }
                        else {
                            return "مختومه";
                        }
                    }}

                />}
                <Column metaForDisplay={DataClass.Ticket.UserCreated} />
                <Action caption="ایجاد فاکتور خدمات" type="Link" showCond={(r) => {

                    return r.status == 1 && r.orderId == null  
                }} pageName="/Ticket/CreateFactor" columnName="id" />
                <Action caption="ویرایش" type="Link" pageName="/Ticket/Edit" columnName="id" />
                <Action caption="ارجاع به فیبربان" type="function" targetFun={ReturnToFixer} />
                <Action caption="انصراف" type="function" targetFun={Cancel} />
                <Action caption="تعیین تکلیف مالی" showCond={(r) => {
                    return window.shareInfo.per.indexOf('AccMang')!=-1;
                }} type="Link" pageName="/Sell/SetPayInfo" columnName="orderId" />
               

            </ProTable>


        }

    </FromBasic>

}
export function CreateFactorForFix(props) {
    let id = useParams().id;
    const [pageState, loadState] = useState({input:null,records:[]});
    const loadData = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Ticket', 'StartForFactor', { id: id }, (data) => {
            loadState({ input: data, records:[] });
        });
    };
    const reclac=()=>
    {
        let sum = 0;
        let helper = new Helper();
        for (let i = 0; i < window.usage.length; i++) {
            let r = window.usage[i];
            if (r.unitPrice != undefined) {
                try {
                    let unitPrice = helper.GetNumber(r.unitPrice);
                    if (unitPrice != 0) {
                        sum += unitPrice * r.amount;
                    }
                }
                catch
                {

                }
            }
        }
  
        $("#txtTotalFactor").val(helper.addCommas(sum));
    }
    const onChange = (dataSource, newValue, index, ColName) => {
        let cmd = this;
        const calcPrice = () => {
            let h = new Helper();
            dataSource[index]['totalPrice'] = dataSource[index]['unitPrice'] * dataSource[index]['count'];
            //cmd.setTotalFactor();
        }
        if ((ColName == 'productId') || (ColName == 'needGranty')) {
            let h = new Helper();
            h.Ajax('Product', 'Get', { id: dataSource[index]['productId'] },
                (data) => {
                    data = data.model;
                    if (data.productType != 0) {
                        dataSource[index]['needGranty'] = false;
                    }
                    if ((ColName == 'productId')) {
                        if (data.productType == 0) {
                            dataSource[index]['needGranty'] = true;
                        }
                    }

                    let needGranty = dataSource[index]['needGranty'];

                    if (ColName == 'productId') {
                        dataSource[index]['unitPrice'] = data.priceInRail + (needGranty == true ? data.granty : 0) - data.discount;
                    }
                    else {
                        dataSource[index]['unitPrice'] = needGranty == true ? dataSource[index]['unitPrice'] + data.granty : dataSource[index]['unitPrice'] - data.granty;
                    }

                    calcPrice();
                    window.OrderItems = dataSource;
                    cmd.setState({ isLoaded: true, Records: window.OrderItems });

                }


            );
        }

        if (ColName == 'unitPrice') {
            calcPrice();
        }
        if (ColName == 'count') {
            calcPrice();
        }
    };





    const submit = () => {
        
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let o = h.GetPostData();
        o.id = id;
        h.Ajax('Ticket', 'CreateFactor', { id: id, totalFactor: o.TotalFactor, productId: o.ProductId, items: window.OrderItems }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    };

    if (pageState.input == null) {
        loadData();
        return <LoadingBar />;
    }
    let newDate = new Date();
    return <div>
        نام و نام خانوادگی   :{pageState.input.model.fullName} آدرس:{pageState.input.model.address} شمراه همراه : {pageState.input.model.mobile}
        <br />
        اقلام مصرفی:
        <ProTable datasourcename="usage" Records={pageState.input.items} afterChange={() => { reclac() }} >
            <Column caption="شرح قلم مصرفی" type={ColumnType.DisplayValue} columnName="stuffName" ></Column>
            <Column caption="مقدار" type={ColumnType.DisplayValue} columnName="amount" ></Column>
            <Column caption="فی" type={ColumnType.InputNumberDigited} columnName="unitPrice" ></Column>
        </ProTable>
        <br />
      

        <FromSubmit submitBev={submit}>
            <InputTextBox caption="هزینه رفع خرابی" columnName="TotalFactor" customHelper={CustomHelper.isDigitngGroupedNumber} mustFill="yes" model="TotalFactor" size="50%"></InputTextBox>
            <br />
            سایر هزینه ها (هزینه خرابی درج نگردد)
            <br/>

            <ProTable rowNumbering={true} afterChange={onChange} datasourcename='OrderItems' Records={pageState.records} Insertable={true} Deleteable={true}>
                <NewRecordValue columnName="startGranteyDate" newValue={new Helper().MilToPer(new Date())}></NewRecordValue>
                <NewRecordValue columnName="endGranteyDate" newValue={
                    new Helper().MilToPer(newDate)
                }></NewRecordValue>
                <NewRecordValue columnName="needGranty" newValue={
                    true
                }></NewRecordValue>
                <NewRecordValue columnName="count" newValue={1}></NewRecordValue>
                <Column type={ColumnType.InputCheck} columnName="needGranty" caption="شامل گارانتی" titleColumnName='productName' />
                <Column metaForInput={DataClass.OrderItem.ProductId} titleColumnName='productName' />
                <Column metaForInput={DataClass.OrderItem.UnitPrice} />
                <Column metaForInput={DataClass.OrderItem.Count} />

                <Column metaForDisplay={DataClass.OrderItem.TotalPrice} />




            </ProTable>
        </FromSubmit>


    </div>;
}








/* ویرایش */
function EditTicket() {
    const queryS = useParams();
    return <AddTicket id={queryS.id} />
}


export class FTTHBoxMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('FTTHBox', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('FTTHBox', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
            <center>
                    <AddButton title='' entity='FTTHBox' />
                        <SimpleButton title="نمایش روی نقشه" onClick={() => {
                            window.open(
                                '/FTTHBox/ShowMap');
                    }} />
                                  <SimpleButton title="نمایش روی نقشه به همراه ثبت نام های جاری" onClick={() => {
                            window.open(
                                '/FTTHBox/ShowMap?ShowReq=yes'); }} />

                    <InputTextBox caption="عنوان " columnName="keyword" size="50%"></InputTextBox>
                    <br />
                    <SimpleButton title="جستجو"

                        onClick={() => {
                            window.open(
                                '/FTTHBox/ShowMap?SerachInColoring=' + window.$('#txtkeyword').val());
                        }}

                    ></SimpleButton>


                </center>





                <ProTable Records={this.state.Records} datasourcename='FTTHBoxs'>
                    <Column metaForDisplay={DataClass.FTTHBox.id} />
                    <Column metaForDisplay={DataClass.FTTHBox.name} />
                    <Column metaForDisplay={DataClass.FTTHBox.address} />
                    <Column metaForDisplay={DataClass.FTTHBox.maincore} />
                    <Column metaForDisplay={DataClass.FTTHBox.spliter} />
                    <Column metaForDisplay={DataClass.FTTHBox.location} />
                  
                    <Action caption="ویرایش" type="Link" pageName="/FTTHBox/Edit" columnName="id" />
                    <Action caption="باکس های متصل" type="Link" pageName="/FTTHBox/Connected" columnName="id" />
                    <Action caption="رنگ های  فیبر" type="Link" pageName="/FTTHBox/Coloring" columnName="id" />


                    <Action caption="حذف" type="function" targetFun={this.Delete}  />




                </ProTable>
            </FromBasic>
        }
    }



}



function EditFTTHBox() {
    const queryS = useParams();
    return <AddFTTHBox id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddFTTHBox extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }

    getCurrentLocation() {
        if (!navigator.geolocation) {
            console.log("Geolocation is not supported by this browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            function (position) {
                const lat = position.coords.latitude;
                const lon = position.coords.longitude;

                console.log("Latitude:", lat);
                console.log("Longitude:", lon);

                $('#txtlocation').val(lat + "," + lon);
            },
            function (error) {
                console.error("Error getting location:", error.message);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    }



    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('FTTHBox', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('FTTHBox', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    pickFromMap() {
        let wi = window.open("/FTTHBox/EditMap?loc=" + $('#txtlocation').val());
        wi.targetFun = (p) => { $('#txtlocation').val(p); };
    }


    render() {
        return <FromSubmit submitBev={this.submit}>
            
            <InputBox meta={DataClass.FTTHBox.name} size='50%' />
            <InputBox meta={DataClass.FTTHBox.Type} size='50%' />
            <InputBox meta={DataClass.FTTHBox.maincore} size='33%' />
            <InputBox meta={DataClass.FTTHBox.spliter} size='33%' />
            <InputBox meta={DataClass.FTTHBox.location} size='33%' />
            <InputBox meta={DataClass.FTTHBox.spliter} size='33%' />
            <InputBox meta={DataClass.FTTHBox.address} size='100%' />
            
            
            <SimpleButton title="دریافت gps" onClick={this.getCurrentLocation}></SimpleButton>
            <SimpleButton title="انتخاب از نقشه" onClick={this.pickFromMap }></SimpleButton>
            {this.id > 0 &&
                <Link to={"/Admin/FTTHBox/Coloring/" + this.id }>
                    <SimpleButton style={{width:'100%'} } title="رنگ بندی"  ></SimpleButton>    </Link>
            }

        </FromSubmit>

    }

}

class BoxSetSelected extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = this.props.id;
        this.state = { Records: [], isLoaded: false };
        this.Submit = this.Submit.bind(this);
    }
    componentDidMount() {
        let helpCls = new Helper();
        let cmd = this;
        helpCls.Ajax('FTTHBox', 'GetConnectd', { id: this.id },
            function (e) {
                console.log('Data Loaded!');
                cmd.setState({ isLoaded: true, Records: e });
            }, function (f) {
                console.log('Error');
            }
        );

    }
    Submit() {
        let hel = new Helper();
        let d = {
            id: this.id,
            selected: hel.GetRecordWithCircita(window.products, 'selected', true)
        };
        let cmd = this;
        hel.Ajax('FTTHBox', 'SetConnectd', d,
            function (data) {
                hel.Alert(data.message, FixedMessage.Result);
                if (data.status == '200') {
                    hel.GoBack();
                }
                else {

                }

            }
            , function (err) {
                hel.Error(FixedMessage.ErrorRaise, FixedMessage.Result);
            }

        )


    }
    render() {
        if (this.state.isLoaded == false) {
            return <LoadingBar />;
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} staticTitle='تعیین مجوز ها' SubmitButtonOnTop={true} submitBev={this.Submit} >



                <ProTable Records={this.state.Records} datasourcename='products'>
                    <Column type={ColumnType.DisplayValue} columnName='boxName' caption='نام باکس' />

                    <Column type={ColumnType.InputCheck} columnName='selected' />
                </ProTable>
            </FromSubmit>

        }

    }
}

    function BoxSubSelected(prop) {
    const id = useParams().id;
        return <BoxSetSelected id={id} />;

}
function CoreColoring(props) {
    const id = useParams().id;
    const [dataProvider, setDataProvider] = useState({ core: [] });
    const [loader, setLoaded] = useState({ isLoaded: false });
    const noneColor = 'url(/Icons/No.png)';
    const colors = ['blue', 'orange', 'green', 'brown', 'slate', 'white', 'red', 'black', 'yellow', 'violet', 'rose', 'aqua'];   window.targetObj = null;
    const setColor=(obj, side)=>
    {
        window.targetObj = obj;
        window.targetSide = side;
       
        $('#txtColor').modal('show');
        $('#txttempValue').val(window.targetObj[window.targetSide + "Name"]);
    }
    const setColorConfirm = (x) => {
        $('#txtColor').modal('hide');
        window.targetObj[window.targetSide] = x;
        window.targetObj[window.targetSide + "Name"] = $("#txttempValue").val();
        setDataProvider({ core: dataProvider.core });
        setTimeout(normalazire, 1000);
    };
    const submit = () => {
        let h = new Helper();
        h.Ajax('FTTHBox', 'SetColor', {  id:id, color: JSON.stringify(dataProvider.core) }
            , (result) => {
                if (result.status == 200) {
                    h.GoBack();
                }
                h.Alert(result.message);
            }
        );



    }
    const load = () => {
        let h = new Helper();
        h.Ajax('FTTHBox', 'Get', { id: id }
            , (result) => {
                setLoaded({ isLoaded: true });
                if (result.coloring != null) {
                    setDataProvider({ core: JSON.parse(result.coloring) });
                    setTimeout(normalazire, 1000);
                }
              
            }
        );




    }

    const normalazire = () => {
        $('table td').css('background-size', '16px');
        $('table .btn-light').css('width', '36px !important');
        $('table .btn-light').css('min-width', '36px !important');
        window.$("td span").each((v,e) => {

             
            var backs = ['black', 'blue', 'red', 'brown'];
            
            if (backs.indexOf(e.parentElement.style.backgroundColor) != -1) {
                $(e).css("color", "white");
            }
            else {
                $(e).css("color", "black");
            }
            e.style.display = "block";
            e.style.width = "100%";
            e.style.height = "100%";
            e.style.textAlign = "center";
            e.style.fontSize = "16px";
            //fitText(e);
            
        });



    }
    function fitText(ele) {
        ele.style.fontSize = "4vw";
        return ;
        const el = ele;
        let fontSize = parseInt(window.getComputedStyle(el).fontSize);

        // تا زمانی که عرض متن از عرض باکس بیشتره، فونت رو کوچیک کن
        while (el.scrollWidth > el.clientWidth && fontSize > 8) {
            fontSize--;
            el.style.fontSize = fontSize + 'px';
        }
    }



    if (loader.isLoaded == false) {
        load();
        return <LoadingBar />;
    }





    return <FromSubmit submitBev={submit}>
        <SimpleButton Icon="New" onClick={() => {
            let newItem = { left: 'white', right: 'black', inner: [] ,leftName:'',rightName:'' };
            dataProvider.core.push(newItem);
            setDataProvider({ core: dataProvider.core });
        }} /> 
            <br />
            {
            dataProvider.core.map((v, i) => {
                return <table id="cbx" border="1px solid">
                    <tr>
                        <td colSpan="4">
                        <InputTextBox caption="نام" size="100%" columnName="name" onChange={(e) => {
                            v.title = e.target.value;
                            }} defaultValue={v.title == undefined ? "" : v.title} />
                        </td>
                    </tr>
                 
                    <tr>
                        <td width="25%" onClick={() => { setColor(v, 'left') }} style={{ minHeight: '64px', border: 'red solid', height: '64px', background: v.left, backgroundSize: '16px' }}><span style={{ color: 'black', textShadow: '0px 0px 10px white' }}> {v.leftName}</span> </td>
                        <td>
                            <SimpleButton style={{ width: '42px', minWidth:'42px' }} Icon="New" onClick={() => {

                                v.inner.push({ left: 'black',leftName:'', right: 'white',rightName:'' });
                           
                            setDataProvider({ core: dataProvider.core });
                        }} /> 
                        <table width="100%">
                            {v.inner.map((x, i2) => {
                                return <tr>
                                    <td onClick={() => { setColor(x, 'left') }} style={{ backgroundSize: '16px', minHeight: '32px', border: 'red solid', height: '32px', background: x.left }}>
                                        <span style={{ color: 'black', textShadow: '0px 0px 10px white' }}>  {x.leftName} </span>
                                    </td>
                                    <td style={{ width: '32px' }}>
                                        <SimpleButton style={{ width: '42px', minWidth: '42px' }} Icon="Delete" onClick={() => {
                                           v.inner.splice(i2, 1);
                                           setDataProvider({ core: dataProvider.core });
                                       }}></SimpleButton>
                                    </td>
                                    <td onClick={() => { setColor(x, 'right') }} style={{ minHeight: '32px', border: 'red solid', height: '32px', background: x.right }}>
                                        <span style={{ color: 'black', textShadow: '0px 0px 10px white' }}>   {x.rightName}</span>
                                    </td>
                                </tr>
                            }
                            )}
                         </table>
                        </td>
                        <td style={{ background: v.right, border: 'red solid', backgroundSize: '16px' }} onClick={() => { setColor(v, 'right') }} width="25%">

                            <span style={{ color: 'black', textShadow: '0px 0px 10px white' }}>     {v.rightName}</span></td>
                        <td width="42px"  >
                            <SimpleButton Icon="Delete" style={{ width: '42px', minWidth: '42px' }} onClick={() => {
                                dataProvider.core.splice(i, 1);
                                setDataProvider({ core: dataProvider.core });
                            }}></SimpleButton>
                        </td>
                    </tr>
                    </table>

                })
        }

        <ModalCustom id="txtColor" dontFull="yes">
            <InputTextBox caption="مقدار" size="100%" columnName="tempValue" onChange={(e) => {
                
            }}  />
       
            {colors.map((q) => {
                return <button type="button" onClick={() => {

                    setColorConfirm(q)
                }} style={{ display: 'block', height: '32px', backgroundSize: 'contain', background: q, borderRadius: '5px', width: '200px', boxShadow: '1px 1px 5px black' }}   >
                

                </button>

            })}
            <button type="button" onClick={() => {

                setColorConfirm(noneColor)
            }} style={{ display: 'block', height: '32px', backgroundSize: '16px', background: noneColor, borderRadius: '5px', width: '200px', boxShadow: '1px 1px 5px black' }}   >
              بدون اتصال

            </button>
        </ModalCustom>

     </FromSubmit>



}

class InternetPackageMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("InternetPackage", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.InternetPackages);
        h.Ajax('InternetPackage', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='InternetPackages' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.InternetPackage.id} />
                    <Column metaForInput={DataClass.InternetPackage.internetType} />
                    <Column metaForInput={DataClass.InternetPackage.Period} />
                    <Column metaForInput={DataClass.InternetPackage.UsageInternetType} />
                    <Column metaForInput={DataClass.InternetPackage.InternetSpeed} />
                    <Column metaForInput={DataClass.InternetPackage.PackageSize} />

                    <Column metaForInput={DataClass.InternetPackage.Price} />

                </ProTable>

            </FromSubmit>

        }

    }


}

export class AddMarketingCall extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.ValidateForItem("txtUserId");
        h.ValidateForItem("txtExpDate");
        h.ValidateForItem("txtCallResult");
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('InternetUser', ( 'MarketingCallInsert' ), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                $('#callUser').modal('hide');
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        
    }
    render() {
        return <FromBasic submitBev={this.submit}>
               <InputBox meta={DataClass.MarketingCall.UserId} size='50%' />
            <InputBox meta={DataClass.MarketingCall.ExpDate} size='50%' />
            <InputBox meta={DataClass.MarketingCall.ServiceAmount} size='50%' />
            <InputBox meta={DataClass.MarketingCall.CallResult} size='50%' />

            <center>
                <SimpleButton title="ثبت" onClick={this.submit}></SimpleButton>
            </center>
        </FromBasic>

    }

}




function InternetUsers() {

    const [pageState, loadState] = useState({ records: [] });

    const serach = () => {
        let h = new Helper();

        h.SaveState();
        let data = h.GetPostData();
        data.recnetMessage = $('#recentMessage').val() == "on";
        h.Ajax('InternetUser', 'Serach', data, (data) => {
            window.InternetUsers = data;
            loadState({ records: data });

        });
    };

    const getCredit = () => {
        let hlp = new Helper();


        hlp.Ajax('SmsReport', 'GetCredit', {}, function (data) {

            hlp.MessageBox(data.message, FixedMessage.Result);

        });

    }


    const sendToSms=()=>
    {
        let hel = new Helper();
        let selected = hel.GetRecordWithCircita(window.InternetUsers, 'selected', true);
        window.mobiles = selected;

        document.getElementById("linker").click();
    }
    const call = (record) => {
        
        $('#callUser').modal('show');
        $("#txtUserId").val(record.userName);
        $("#txtExpDate").val(record.expDate);
    };
    return <FromBasic>
        <ExcelImporter targetName="InternetUser" callbackFun={() => {
   

        }} ></ExcelImporter>
        <Link id="linker" to="/Admin/SendSmsDirect"></Link>
        <InputTextBox caption="نام" columnName="name" size="50%" model="name"></InputTextBox>
        <InputTextBox caption="شماره موبایل" columnName="mobile" size="50%" model="mobile"></InputTextBox>
        <InputTextBox caption="از " columnName="StartDay" size="50%" mustFill="yes" model="StartDay"></InputTextBox>
        <InputTextBox caption="تا" columnName="EndDay" size="50%" mustFill="yes" model="EndDay"></InputTextBox>
        <InputTextBox caption="نام نمایندگی" columnName="seller" size="33%" model="seller"></InputTextBox>
        <InputTextBox caption="شهر" columnName="city" size="33%" model="city"></InputTextBox>
        <InputTextBox caption="سرویس" columnName="serviceName" size="33%" model="serviceName"></InputTextBox>
      

        <center>
            <input type="checkbox" id="recentMessage" ></input>
            اگر اخیر پیامک داده شده نمایش داده نشود
            <SimpleButton title="جستجو" onClick={serach}></SimpleButton>
            <SimpleButton title="ارسال پیامک" onClick={sendToSms}></SimpleButton>
            <SimpleButton onClick={getCredit} title="استعلام موجودی" ></SimpleButton>
        </center>
        <ModalCustom dontFull="YES" id="callUser" >
            <AddMarketingCall />
        </ModalCustom>
        <ProTable Records={pageState.records} datasourcename='InternetUsers'>
            <Column metaForDisplay={DataClass.InternetUser.InternetCurrentType} />
            <Column metaForDisplay={DataClass.InternetUser.UserName} />
            <Column metaForDisplay={DataClass.InternetUser.FristName} />
            <Column metaForDisplay={DataClass.InternetUser.LastName} />
            <Column metaForDisplay={DataClass.InternetUser.Mobile} />
            <Column enumFilterAuto={true}  metaForDisplay={DataClass.InternetUser.DurService} />
            <Column metaForDisplay={DataClass.InternetUser.CityName} />
            <Column metaForDisplay={DataClass.InternetUser.ServiceName} />
            <Column enumFilterAuto={true } metaForDisplay={DataClass.InternetUser.Seller} />
            <Column metaForDisplay={DataClass.InternetUser.ExpDate} />
            <Column metaForDisplay={DataClass.InternetUser.ExpTitle} />
            <Column columnName="lastCallText" caption="آخرین تماس" type={ColumnType.FunctionValue} customFunction={(r) => {
                let hel = new Helper();
                if (r.lastCall == null) {
                    return "تماسی گرفته نشده";
                }

                return r.lastCall.callTime + " " + hel.GetCaptionFromEnum(enums.CallResult, r.lastCall.callResult);
            }}></Column>

            <Column type={ColumnType.InputCheck} columnName='selected' />


            <Action caption="ویرایش" type="Link" pageName="/InternetUser/Edit" columnName="userName" />
            <Action caption="تماس" type="function" targetFun={call} />



        </ProTable>


    </FromBasic>

}





export class AddInternetUser extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('InternetUser', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('InternetUser', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
           
            <InputBox meta={DataClass.InternetUser.FristName} size='50%' />
            <InputBox meta={DataClass.InternetUser.LastName} size='50%' />
            <InputBox meta={DataClass.InternetUser.Mobile} size='50%' />
            <InputBox meta={DataClass.InternetUser.ExpDate} size='50%' />
        

        </FromSubmit>

    }

}

function EditInternetUser() {
    const queryS = useParams();
    return <AddInternetUser id={queryS.id} />
}

function MarketReporting() {

    const [pageState, loadState] = useState({ records: [] });

    const serach = () => {
        let h = new Helper();

        h.SaveState();
        let data = h.GetPostData();
     
        h.Ajax('InternetUser', 'MarketReportingTime', data, (data) => {
            window.InternetUsers = data;
            loadState({ records: data });

        });
    };


    return <FromBasic>
        <InputTextBox caption="از تاریخ" columnName="start" model="start" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="تا تاریخ" columnName="end" model="end" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
        </center>
        <ProTable datasourcename="report" Records={pageState.records}>
            <Column metaForDisplay={DataClass.MarketingCallReport.UserTitle} />
            <Column metaForDisplay={DataClass.MarketingCallReport.CallResult} />
            <Column metaForDisplay={DataClass.MarketingCallReport.Count} />
            <Column metaForDisplay={DataClass.MarketingCallReport.SumAmount} />
        </ProTable>
    </FromBasic>


}




export function ModemInstallAndServiceApp(props) {
    return [<Route path="SetUserForService" element={<SetUsers />} />
        , <Route path="UsageStuffs" element={<UsageStuffMgt />} />
        , <Route path="NewMission" element={<NewMission />} />,
        <Route path="Ticket/Add" element={<AddTicket id="-1" />} ></Route>,
                <Route path="Ticket/CreateFactor/:id" element={<CreateFactorForFix/>} ></Route>
        , <Route path="Tickets" element={<TicketSerach id="-1"  key="1"/>} ></Route>,
        , <Route path="Tickets/ReadyForFactor" element={<TicketSerach id="-1" mode="ReadyForFactor" key="2" />} ></Route>,
        , <Route path="Tickets/UnPayed" element={<TicketSerach id="-1" mode="UnPayed" key="3" />} ></Route>,
        <Route path="Ticket/Edit/:id" element={<EditTicket />} />
        , <Route path="EditJob/:id" element={<NewMission />} />
        , <Route path="ICanDo/:id" element={<CanDoIt />} />,
        , <Route path="ReportMarketing" element={<MarketReporting />} />,
        <Route path="CreateDoc" element={<CreateDocAuto />} />
        , <Route path="AllMissions" element={<MyActiveMission type={ContactType.admin} key={3 } />} />
        , <Route path="AllMissions/:status" element={<MyActiveMission type={ContactType.admin} key={4} />} />
        , <Route path="DoneJob/:type/:id" element={<SetAnwser />} />
        , <Route path="EditJobUsage/:type/:id" element={<SetAnwser editMode={true} />} />
        , <Route path="ReportCurrentStorage" element={<ReportCurrentStorages />} />
        , <Route path="GetCurrentUsages" element={<ReportUsages />} />
        , <Route path="TimingReport" element={<ReportCurrentTiming />} />
        , <Route path="TimingReportMe" element={<ReportCurrentTiming isMe={true } />} />
        , <Route path="GetCurrentUsagesMe" element={<ReportUsages isMe={true } />} />
        , <Route path="ReportCurrentStorageMe" element={<ReportCurrentStorages isMe={true } />} />,

        <Route path="FTTHBoxs" element={<FTTHBoxMgt />} />,
<Route path="FTTHBox/Add" element={<AddFTTHBox id="-1" />} />,
                                           <Route path="FTTHBox/Edit/:id" element={<EditFTTHBox />} />,
        <Route path="FTTHBox/Connected/:id" element={<BoxSubSelected />} />,
        <Route path="FTTHBox/Coloring/:id" element={<CoreColoring />} />,
        , <Route path="FTTHRequest/New" element={<AddFTTHRequest />} />
        , <Route path="FTTHRequest/Confrim/:id" element={<EditFTTHRequestAnswer />} />
        , <Route path="FTTHRequestInBox" element={<FTTHRequestMgt archvieMode={false} key="1" />} />
        , <Route path="FTTHRequestArchive" element={<FTTHRequestMgt archvieMode={true} key="2" />} />
        , <Route path="MyActiveMissionAsInstaller" element={<MyActiveMission type={ContactType.installer} key={new Date().toString()} />} />
        , <Route path="MyActiveMissionAsFiojaner" element={<MyActiveMission type={ContactType.fiojanr} />} key={new Date().toString()} />
        , <Route path="MyActiveMissionAsFixer" element={<MyActiveMission type={ContactType.fixer} />} key={new Date().toString()} />
        ,<Route path="DelevryUsages" element={<DelevryUsageMgt />} />
,<Route path="DelevryUsage/Add" element={<AddDelevryUsage id="-1" />} />
                                          , <Route path="DelevryUsage/Edit/:id" element={<EditDelevryUsage />} />
        , <Route path="InternetPackages" element={<InternetPackageMgt />} />
        , <Route path="InternetUsers" element={<InternetUsers />} />
        , <Route path="InternetUser/Edit/:id" element={<EditInternetUser />} />


    ];
}